export default [
  {
    title: 'จัดการแคมเปญ Redeem',
    route: 'redeem-management',
    icon: 'TagIcon',
    resource: 'redeem-management',
    action: 'all',
  },
]
